import React from "react";
import QuestionWriteForm from "../../../controllers/Questions/QuestionWriteForm";
import { useLocaleContext } from "../../../context/LocaleContext";
import { useModalContext } from "../../../context/ModalContext";
import ButtonQuestionWriteForm from "../../SideModule/ButtonQuestionWriteForm";
import { useQuestionsContext } from "../../../context/QuestionsContext";

const ButtonQuestionWriteFormWrapper = ({
    settings = null,
    title,
    isShow = true,
    onClick = () => {},
    moduleRef,
    episode,
    member,
    selectStream,
    ButtonComponent = ButtonQuestionWriteForm,
}) => {
    const { renderModal } = useModalContext();
    const $locale = useLocaleContext();
    const { enabled: questionsEnabled, isAvailableReceivingQuestions } = useQuestionsContext();

    const handleOpenQuestionWriteForm = async () => {
        onClick();
        renderModal(
            QuestionWriteForm,
            {episode, member, selectStream, $locale, lockPageScroll: false},
            null,
            true,
            moduleRef?.current
        );
    }

    if (!isShow || !questionsEnabled || !isAvailableReceivingQuestions) {
        return null;
    }

    return (
        <ButtonComponent
            settings={settings}
            onClick={handleOpenQuestionWriteForm}
            title={title || $locale.get('questions.button')}
        />
    );
}

export default ButtonQuestionWriteFormWrapper;
